<template>
  <v-card>
    <v-card-text class="text--primary">
      <v-list two-line>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Id
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.id }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Name
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.name }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Creation datetime
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.createdAt | DateWithMinutes }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Birthday
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ reformatDate(patient.birthday) | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Gender
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patientGender | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Email
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.email | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Phone
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.phone | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Address
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.address | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Comment
            </v-list-item-title>
            <v-list-item-subtitle>
              {{ patient.comment | NoEmpty }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>
              Cases
            </v-list-item-title>
            <v-list-item-subtitle>

          <span v-for="(c, index) in patient.patientCases" :class="{'ml-1': index > 0 }">
              <router-link
                  :to="{ name: 'updatePgtCase', params: { caseSystemId: c.caseSystemId }}">{{ c.caseSystemId }}</router-link>
          </span>
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import {mapGetters} from 'vuex'
import {reformatDate} from '@/helpers/timeformats'
import NoEmpty from '@/components/Filters/NoEmpty'
import DateWithMinutes from '@/components/Filters/DateWithMinutes'

// clientIds: ["2697b3d2-3848-4f17-99f4-9c828c4cb413"]
// comment: null
// email: null
// patientCases: [{caseId: "9b3da837-06a3-4e53-b439-b4d12edaf425", caseSystemId: "1727",…}]
// phone: null

export default {
  name: 'OverviewPatient',
  props: {
    patient: Object
  },
  filters: {
    NoEmpty,
    DateWithMinutes
  },
  computed: {
    ...mapGetters({
      availableGendersByValue: 'availableGendersByValue'
    }),
    patientGender() {
      return _.get(this.availableGendersByValue, [this.patient.gender, 'title'], null)
    }
  },
  methods: {
    reformatDate: reformatDate
  }
}
</script>

<style scoped>

</style>